module.exports = {"top3":["Adults with any mental illness reporting unmet need","Drug poisoning deaths","Adults who have lost six or more teeth"],"bottom3":["Uninsured children","Adults who went without care because of cost","Uninsured adults"],"most_improved":["Nursing home residents with an antipsychotic medication","Home health patients without improved mobility","Diabetic adults without an annual hemoglobin A1c test"],"most_declined":["Hospital 30-day mortality","Preventable hospitalizations ages 18-64","Children who did not receive needed mental health care"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/TX.json
// module id = 283
// module chunks = 143196823979170 184088790168614